import {createSelector} from 'reselect'
import {getTimeZoneGroups, getUserGroupsWithDefault, getUsers} from '../../../entities/selectors'
import {getActiveTabNum, getNewUsersIdSet, getUsersListForWorkAssignmentsTab} from '../common/selectors'
import {createGroupComparator} from '../../../util/groupUtils'
import {UserManagementConstants} from 'constants'
import GroupType from "../../../enums/GroupType"
import {createWarningMsgs, convertUsersFilterDependingOnFeatures} from "../utils"
import {isTZGEnabled, isUGREnabled} from '../../../features/selectors'

const getWorkAssignmentsState = state => state.userManagement.workAssignmentsTab

export const getUserIdsOrder = state => getWorkAssignmentsState(state).userIdsOrder

export const getUsersList = createSelector(
    getUserIdsOrder,
    getUsers,
    (userIds, usersMap) => {
        return userIds.map(id => usersMap[id])
    }
)

export const isLoaded = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.loaded
)

export const isLoading = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.loading
)

export const getWordsFilter = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.wordsFilter
)

export const getSubmittedWordsFilter = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.submittedWordsFilter
)

export const getCurrentPageNum = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.currentPageNum
)

export const getWorkAssignmentsFilter = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.workAssignmentsFilter
)

export const getUsersFilter = createSelector(
    getWorkAssignmentsState,
    isUGREnabled,
    isTZGEnabled,
    getUsersListForWorkAssignmentsTab,
    (wa, ugrEnabled, tzgEnabled, availableUsers) => {
        return convertUsersFilterDependingOnFeatures(wa.usersFilter, ugrEnabled, tzgEnabled, availableUsers)
    }
)

export const getSorting = createSelector(
    getWorkAssignmentsState,
    isUGREnabled,
    isTZGEnabled,
    (wa, ugrEnabled, tzgEnabled) => {
        if (!ugrEnabled && wa.sorting.order === UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME ||
            !tzgEnabled && wa.sorting.order === UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME) {
            return {
                order: UserManagementConstants.USER_LIST_ORDER_BY_NAME,
                asc: true,
            }
        }
        return wa.sorting
    }
)

export const getNUsersPerPage = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.nUsersPerPage
)

export const getNTotalUsers = createSelector(
    getWorkAssignmentsState,
    (wa) => wa.nTotalUsers
)

export const isNeedToReloadData = createSelector(
    isLoaded,
    getActiveTabNum,
    (loaded, tabNum) => {
        return loaded === false && tabNum === UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM
    }
)

export const getSortedUserGroupsList = createSelector(
    getUserGroupsWithDefault,
    (userGroups) => {
        return Object.values(userGroups).sort(createGroupComparator(GroupType.USER_GROUP))
    }
)

export const getSortedTimeZoneGroupsList = createSelector(
    getTimeZoneGroups,
    (timeZoneGroups) => {
        return Object.values(timeZoneGroups).sort(createGroupComparator(GroupType.TIME_ZONE_GROUP))
    }
)

export const getWarningMsgsByUserId = createSelector(
    getUsersList,
    getNewUsersIdSet,
    (users, newIds) => {
        const warnings = {}
        users.forEach(user => {
            warnings[user.id] = createWarningMsgs(user, !!newIds[user.id])
        })
        return warnings
    }
)

export const getUsersWorkAssignmentsCounters = (state) => getWorkAssignmentsState(state).usersWorkAssignmentsCounters



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/selectors.js